import { InputHTMLAttributes } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { cn } from "../utils/cn";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  register: UseFormRegisterReturn
  error?: string
}

const FormInput = ({ label, register, error, ...rest }: Props) => {
  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-text-main mb-1">{label}</label>
      <input
        {...register}
        {...rest}
          className={cn(
          "w-full bg-white text-text-main placeholder-gray-400 rounded-xl px-4 py-3 font-sans text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-primary",
          error && "border border-danger",
          !error && "border border-border",
        )}
      />
      {error && <p className="text-danger text-sm mt-1">{error}</p>}
    </div>
  )
}

export default FormInput
